import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { useCategories } from '@/context/CategoriesContext';
import { PublicHeader } from '@/components/marketplace/PublicHeader';
import { CategoriesGrid } from '@/pages/HomePage';
import { AdCard } from '@/components/marketplace/AdCard';
import { Skeleton } from '@/components/ui/skeleton';

export default function CategoryPage() {
    const { slug } = useParams();
    const cats = useCategories();
    const [ads, setAds] = useState([]);
    const cat = cats.find(x => x.slug === slug) || null;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get('/ads', { params: { category: slug, limit: 48 } })
            .then(r => { setAds(r.data.items); })
            .finally(() => setLoading(false));
    }, [slug]);

    return (
        <div className="min-h-screen flex flex-col">
            <PublicHeader />
            <main className="flex-1">
                {/* Category hero */}
                {cat && (
                    <section className="relative h-56 sm:h-64 overflow-hidden">
                        <img src={cat.image_url} alt="" className="absolute inset-0 h-full w-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/50 to-transparent" />
                        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-full flex flex-col justify-end pb-6">
                            <Link to="/" className="text-xs text-white/80 hover:text-white">← Volver</Link>
                            <h1 className="text-3xl sm:text-4xl font-bold text-white mt-1">{cat.name}</h1>
                            <p className="text-white/85 text-sm">{ads.length} anuncios</p>
                        </div>
                    </section>
                )}

                {/* Category rail (mini banners horizontal) */}
                <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-10 pt-4">
                    <CategoriesGrid cats={cats} compact />
                </div>

                <section className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-10 py-6">
                    {loading ? (
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5">
                            {[...Array(8)].map((_, i) => <Skeleton key={i} className="aspect-[4/5] rounded-2xl" />)}
                        </div>
                    ) : ads.length === 0 ? (
                        <div className="text-center py-20 text-muted-foreground">Aún no hay anuncios en esta categoría.</div>
                    ) : (
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5">
                            {ads.map(a => <AdCard key={a.id} ad={a} />)}
                        </div>
                    )}
                </section>
            </main>
        </div>
    );
}
